const red = {
  100: '#FF574F',
  50: '#FFABA7',
  30: '#FFCDCA',
  10: '#FFEEED',
};
export default red;
